export const PRISMIC_CONFIG_FILENAME = "prismic.config.json";
